// Version : 1.0.0
// Author : AGALYA
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** FAMILY MEMBER INCOME ADD START *********************** */
export const familyMemberIncomeAdd = (verifyData: any) => {
	const data = {
		CreateFamilyIncomeToken: verifyData,
	};
	const url = `${API_URL}updateFamilyMemberIncome`;
	return makeApiCall(url, data);
};
/** ***************** FAMILY MEMBER INCOME ADD END *********************** */

/** ***************** FAMILY MEMBER FETCH START *********************** */
export const familyMemberFetch = (verifyData: any) => {
	const data = {
		FetchMemberDetailsToken: verifyData,
	};
	const url = `${API_URL}fetchFamilyIncomeAndDetails`;

	return makeApiCall(url, data);
};
/** ***************** FAMILY MEMBER FETCH END *********************** */

/** ***************** FAMILY MEMBER ADD DETAILS START *********************** */
export const familyMemberAddDetails = (verifyData: any) => {
	const data = {
		CreateFamilyToken: verifyData,
	};
	const url = `${API_URL}addFamilyMember`;
	return makeApiCall(url, data);
};
/** ***************** FAMILY MEMBER ADD DETAILS END *********************** */

/** ***************** FAMILY MEMBER FETCH PARTICULAR START *********************** */
export const familyMemberFetchParticular = (verifyData: any) => {
	const data = {
		FetchMemberDetailsToken: verifyData,
	};
	const url = `${API_URL}fetchParticularFamilyMember`;
	return makeApiCall(url, data);
};
/** ***************** FAMILY MEMBER FETCH PARTICULAR END *********************** */

/** ***************** DELETE MEMBER FAMILY START *********************** */
export const DeleteMemberFamilyAPI = (verifyData: any) => {
	const data = {
		FamilyMemberDeleteToken: verifyData,
	};
	const url = `${API_URL}deleteParticularFamilyMember`;
	return makeApiCall(url, data);
};
/** ***************** DELETE MEMBER FAMILY END *********************** */

/** ***************** VERIFY FAMILY AADHAR OTP START *********************** */
export const verifyFamilyAadharOtpAPI = (credentials: any, serviceName: string) => {
	const data = {
		AadharOtpVerificationToken: credentials,
	};
	const url = `${API_URL + serviceName}`;
	return makeApiCall(url, data);
};
/** ***************** VERIFY FAMILY AADHAR OTP END *********************** */

/** ***************** VERIFY VALIDATE FAMILY AADHAR OTP START *********************** */
export const verifyValidateFamilyAadharOtpAPI = (credentials: any, serviceName: string) => {
	const data = {
		AadharValidateOtpVerificationToken: credentials,
	};
	const url = `${API_URL + serviceName}`;
	return makeApiCall(url, data);
};
/** ***************** VERIFY VALIDATE FAMILY AADHAR OTP END *********************** */
